import * as React from 'react';
import PropTypes from 'prop-types';

import SvgIcon from '@mui/material/SvgIcon';

const MORE_VERT_PATH_D =
  'M13.9999 10.6663C14.9166 10.6663 15.6666 9.91634 15.6666 8.99967C15.6666 8.08301 14.9166 7.33301 13.9999 7.33301C13.0833 7.33301 12.3333 8.08301 12.3333 8.99967C12.3333 9.91634 13.0833 10.6663 13.9999 10.6663ZM13.9999 12.333C13.0833 12.333 12.3333 13.083 12.3333 13.9997C12.3333 14.9163 13.0833 15.6663 13.9999 15.6663C14.9166 15.6663 15.6666 14.9163 15.6666 13.9997C15.6666 13.083 14.9166 12.333 13.9999 12.333ZM13.9999 17.333C13.0833 17.333 12.3333 18.083 12.3333 18.9997C12.3333 19.9163 13.0833 20.6663 13.9999 20.6663C14.9166 20.6663 15.6666 19.9163 15.6666 18.9997C15.6666 18.083 14.9166 17.333 13.9999 17.333Z';

const MoreVertIcon = ({ width = 28, height = 28, color = '#747487' }) => (
  <SvgIcon
    viewBox="0 0 28 28"
    fill="none"
    sx={{
      width,
      height,
      borderRadius: '4px',
      opacity: 1,
      color,
      '& > rect[data-more-vert-hover-bg]': {
        opacity: 0,
        transition: 'opacity 120ms ease-in-out',
      },
      '.MuiIconButton-root:hover & > rect[data-more-vert-hover-bg], &:hover > rect[data-more-vert-hover-bg]':
        {
          opacity: 1,
        },
    }}
  >
    <rect data-more-vert-hover-bg width="28" height="28" rx="4" fill="#F2F2F5" />
    <path d={MORE_VERT_PATH_D} fill="currentColor" />
  </SvgIcon>
);

MoreVertIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};

export default MoreVertIcon;
